import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum ReportRouteNames {
  REPORT_TABLE = "PartnerReportTable",
  REPORT_LIST = "PartnerReports",
  REPORT_DETAIL = "PartnerReportsDetailView",
  REPORT_GROUP_DETAIL = "REPORT_GROUP_DETAIL",
  REPORT_GROUP_TABLE = "REPORT_GROUP_TABLE",
  REPORT_GROUP_CUSTOM_VIEW = "REPORT_GROUP_CUSTOM_VIEW"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type Report = { reportId: string };
type ReportGroup = { reportGroupId: string };
type View = { viewId: string };
type Query = { query?: Record<string, string> };

export class ReportGoToHelper extends BaseGoToHelper {
  static get breadCrumbs() {
    const locations = ReportGoToHelper.locations;

    return {
      ReportTable: (partnerId: string) => {
        return {
          text: $t("report.people").toString(),
          exact: true,
          to: locations.reportTable({ partnerId })
        };
      },
      ReportList: (partnerId: string) => {
        return {
          text: $t("report.reportGroups").toString(),
          exact: true,
          to: locations.reportList({ partnerId })
        };
      },
      ReportDetail: (partnerId: string, reportId: string) => {
        return {
          text: $t("report.report").toString(),
          exact: true,
          to: locations.reportDetail({ partnerId, reportId })
        };
      },
      ReportGroupTable: (partnerId: string) => {
        return {
          text: $t("report.reportGroups").toString(),
          exact: true,
          to: locations.reportGroupTable({ partnerId })
        };
      },
      ReportGroupCustomView: (partnerId: string, reportGroupId: string, viewId?: string) => {
        return {
          text: $t("report.reportGroup").toString(),
          exact: true,
          to: locations.reportGroupCustomView({ partnerId, reportGroupId, viewId: viewId ?? "0" })
        };
      },
      ReportGroupDetail: (partnerId: string, reportGroupId: string) => {
        return {
          text: $t("common.verbs.edit").toString(),
          exact: true,
          to: locations.reportGroupDetail({ partnerId, reportGroupId })
        };
      }
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    reportTable: (d: Partner & Query) => {
      return {
        name: ReportRouteNames.REPORT_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    reportList: (d: Partner & Query) => {
      return {
        name: ReportRouteNames.REPORT_LIST,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    reportDetail: (d: Partner & Report & Query) => {
      return {
        name: ReportRouteNames.REPORT_DETAIL,
        params: { partnerId: d.partnerId, reportId: d.reportId },
        query: d.query
      };
    },
    reportGroupDetail: (d: Partner & ReportGroup & Query) => {
      return {
        name: ReportRouteNames.REPORT_GROUP_DETAIL,
        params: { partnerId: d.partnerId, reportGroupId: d.reportGroupId },
        query: d.query
      };
    },
    reportGroupTable: (d: Partner & Query) => {
      return {
        name: ReportRouteNames.REPORT_GROUP_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    reportGroupCustomView: (d: Partner & ReportGroup & View & Query) => {
      return {
        name: ReportRouteNames.REPORT_GROUP_CUSTOM_VIEW,
        params: { partnerId: d.partnerId, reportGroupId: d.reportGroupId, viewId: d.viewId },
        query: d.query
      };
    }
  };

  goToReportTable(d: Tab & Partner) {
    this.go(ReportGoToHelper.locations.reportTable(d), d.newTab);
  }

  goToReportDetail(d: Tab & Partner & Report) {
    this.go(ReportGoToHelper.locations.reportDetail(d), d.newTab);
  }

  goToReportGroupTable(d: Tab & Partner) {
    this.go(ReportGoToHelper.locations.reportGroupTable(d), d.newTab);
  }

  goToReportGroupDetail(d: Tab & Partner & ReportGroup) {
    this.go(ReportGoToHelper.locations.reportGroupDetail(d), d.newTab);
  }

  goToReportGroupCustomView(d: Tab & Partner & ReportGroup & View) {
    this.go(ReportGoToHelper.locations.reportGroupCustomView(d), d.newTab);
  }
}
